import { Instagram, ArrowUpRight } from "lucide-react";
import { KineticLine, FadeUp } from "@/components/KineticText";
import { LogoMark } from "@/components/Logo";
import WhatsAppIcon from "@/components/WhatsAppIcon";
import { INSTAGRAM, WHATSAPP_DEFAULT_MESSAGE, whatsappLink } from "@/data/site";

export default function Footer() {
  return (
    <footer id="contato" data-testid="contact-section" className="bg-mist">
      <div className="mx-auto max-w-[1400px] px-6 pb-10 pt-24 md:px-12 md:pt-36">
        <FadeUp>
          <p className="text-xs font-medium uppercase tracking-[0.35em] text-dusk">Contato</p>
        </FadeUp>

        <h2
          data-testid="contact-title"
          className="mt-6 font-serif font-light leading-[0.98] text-navy"
          style={{ fontSize: "clamp(2.75rem, 8vw, 7rem)" }}
        >
          <KineticLine>Bora navegar</KineticLine>
          <KineticLine delay={0.12}>
            <em className="italic text-sea">juntos?</em>
          </KineticLine>
        </h2>

        <div className="mt-12 grid gap-10 md:mt-16 md:grid-cols-12 md:items-end">
          <FadeUp className="md:col-span-6">
            <p className="max-w-md text-base font-light leading-relaxed text-dusk md:text-lg">
              Conte pra gente a travessia dos seus sonhos. Chame no WhatsApp ou no
              Instagram e a gente monta tudo — da cabine ao embarque.
            </p>
          </FadeUp>

          <FadeUp delay={0.1} className="md:col-span-6 md:flex md:justify-end">
            <div className="flex flex-col gap-4 sm:flex-row sm:flex-wrap md:justify-end">
              <a
                href={INSTAGRAM.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-instagram-button"
                className="group inline-flex items-center gap-4 bg-navy px-8 py-5 text-paper transition-colors duration-300 hover:bg-[#123158]"
              >
                <Instagram size={20} strokeWidth={1.6} />
                <span className="flex flex-col items-start leading-tight">
                  <span className="text-[0.6rem] uppercase tracking-[0.3em] text-air">
                    Atendimento online
                  </span>
                  <span className="mt-1 text-sm font-medium tracking-wide">{INSTAGRAM.handle}</span>
                </span>
                <ArrowUpRight
                  size={18}
                  className="ml-2 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                />
              </a>
              <a
                href={whatsappLink(WHATSAPP_DEFAULT_MESSAGE)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-whatsapp-button"
                className="group inline-flex items-center gap-4 border border-navy px-8 py-5 text-navy transition-colors duration-300 hover:bg-navy hover:text-paper"
              >
                <WhatsAppIcon size={20} />
                <span className="flex flex-col items-start leading-tight">
                  <span className="text-[0.6rem] uppercase tracking-[0.3em] text-sea group-hover:text-air">
                    Conversa instantânea
                  </span>
                  <span className="mt-1 text-sm font-medium tracking-wide">WhatsApp</span>
                </span>
                <ArrowUpRight
                  size={18}
                  className="ml-2 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                />
              </a>
            </div>
          </FadeUp>
        </div>

        <div className="mt-20 border-t border-cloud pt-8 md:mt-28">
          <div className="flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-center">
            <span className="flex items-center gap-3">
              <LogoMark className="h-7 w-7" />
              <span className="font-serif text-base text-navy">SG Turismos</span>
            </span>
            <p className="text-[0.65rem] uppercase tracking-[0.3em] text-dusk">
              © {new Date().getFullYear()} SG Turismos · Feito com amor pelo mar
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
